enum Player {
  FirstPlayer = "FirstPlayer",
  SecondPlayer = "SecondPlayer",
}

export default Player;